module.exports = __webpack_public_path__ + "img/abgc2.05450ab1.jpg";